import { useFormik } from 'formik';
import moment from 'moment';
import QRCode from 'qrcode.react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from 'react-to-print';
import { Container, Form, FormFeedback, Input } from 'reactstrap';
import * as Yup from 'yup';
import logolight from "../../../assets/images/holcimlogoAdipi.png";
import { getLabRequestSample } from "../../../store/labCitec/labRequestSamples/actions";

export const LabRequestSamplePrintView = (props) => {

    const obj = JSON.parse(localStorage.getItem("authUser"))
    const dispatch = useDispatch();
    const [userName, setUserName] = useState(`${obj.name ?? ''} ${obj.surname ?? ''}`)

    useEffect(() => {
        dispatch(getLabRequestSample(`/${props.location.pathname.split('/')?.slice(-1)[0]?.toString()}`))
    }, [])

    const { labRequestSample } = useSelector(state => ({
        labRequestSample: state.labRequestSampleReducer.labRequestSample,
    }));

    const [isUpdate, setIsUpdate]= useState(true)

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    const validation = useFormik({
      // enableReinitialize : use this flag when initial values needs to be changed
      enableReinitialize: true,
      initialValues: {
          id: labRequestSample?.labRequest?.id ?? '',
          labRequestCode: labRequestSample?.labRequest?.code ?? '',
          identifier: labRequestSample.sampleControlIdentifier,
          createdAt: isUpdate && labRequestSample.createdAt ? (moment.utc(labRequestSample.createdAt).format('YYYY-MM-DD')) : null,
          dateAt: isUpdate && labRequestSample.dateAt ? (moment.utc(labRequestSample.dateAt).format('YYYY-MM-DD')) : null,
          receivedAt: isUpdate && labRequestSample.receivedAt ? (moment.utc(labRequestSample.receivedAt).format('YYYY-MM-DD')) : null,
          quantity: isUpdate ? labRequestSample.quantity : 0,
          code: isUpdate ? labRequestSample.code : '',
          kind: isUpdate ? labRequestSample.kind?.name ?? '':'',
          unitMeasure: isUpdate ? labRequestSample.unitMeasure?.name ?? '':'',
          location: isUpdate ? labRequestSample.location?.name ?? '':'',
          region: isUpdate ? `${labRequestSample.region?.state ?? ''}-${labRequestSample.region?.municipality ?? ''}` : '',
          description: isUpdate ? labRequestSample.name ?? '' : '',
          observations: isUpdate ? labRequestSample.observations ?? '' : '',
          labArea: isUpdate ? labRequestSample.laboratoryArea?.name ?? '':'',
          labSegment: isUpdate ? labRequestSample.laboratorySegment?.name ?? '':'',
          coordination: isUpdate ? labRequestSample.coordination?.name ?? '':'',
      },
      validationSchema: Yup.object({
          identifier: Yup.number().required('Ingrese el identificador'),
          quantity: Yup.number().required('Ingrese la cantidad'),
          description: Yup.string().required("Ingrese la descripción"),
          observations: Yup.string().required("Ingrese las observaciones"),
      }),
      onSubmit: (values, { resetForm }) => {
          resetForm()
      }
    });

    const retrieveEnvironmentUrl = () => {
        const envs = {
            PROD: 'https://dipi.holcimmexico.com',
            LOWER: 'http://10.112.26.120:82'
        };

        const environment = process.env.REACT_APP_NODE_ENV === 'production' ? 'PROD' : 'LOWER';
        return envs[environment];
    }

    const retrieveLaboratoryType = () => {
        return 'labCitec';
    }

    const handleQrValue = (id) => {
        const env = retrieveEnvironmentUrl();
        return `${env}/${retrieveLaboratoryType()}/${id}`;
    }

    return (
    <React.Fragment>
        <div className="page-content">
            <Container fluid className="" >
                <div className="d-flex align-items-center justify-content-end mb-3">
                    <button onClick={() => { handlePrint() }} className="btn btn-primary rounded-3 py-2 mx-4">
                        <span className="mdi mdi-printer me-2"></span>Imprimir
                    </button>
                    <button onClick={() => { props.history.goBack() }} className="btn btn-success rounded-3 py-2">
                        <span className="mdi mdi-keyboard-backspace me-2"></span>Atrás
                    </button>
                </div>
                <Form
                    className="form-horizontal mt-3 mb-1"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                    ref={componentRef}
                >
                    <div className='row'>
                        <div className='col-3 col-md-4'>
                            <div className='d-flex align-items-center justify-content-end' /*style={{position:'relative',left:'50px'}}*/>
                                <div className='pt-4'>
                                <img src={logolight} alt="" height="48" className="logo logo-dark" />
                                </div>
                            </div>
                        </div>
                        <div className='col-3 col-md-8'>
                            <div className='text-center text-primary' style={{fontSize:'30px', color:'blue'}}>
                                <b>Holcim México Operaciones</b>
                            </div>
                            <div className='text-center text-success mt-1' style={{fontSize:'19px', color:'blue'}}>
                                <b>Centro de Innovación Tecnológica para la Construcción</b>
                                </div>
                            <div className='text-center text-info mt-1' style={{fontSize:'16px', color:'blue'}}>
                                <b>Carretera Toluca-Atlacomulco No. 1530 Lote 2 Col. Santa Cruz Atzcapotzaltongo Toluca, Edo. Mex. CP 50010</b>
                                </div>
                            </div>
                        </div>
                    <div className='row'>
                        <div className='col-3 col-md-7'>
                            <div className='text-primary row mx-4 my-3' style={{fontSize:'20px', color:'blue'}}>
                                <b>Inspección e Identificación de Muestras</b>
                            </div>
                            <div className='row my-1'>
                                <div className='col-3 col-md-4'>
                                    <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                                    <label className='text-primary ml-1'>No. Muestra: {`${validation.values.identifier}`}</label>
                                    </div>
                                </div>
                                <div className='col-3 col-md-8'>
                                    <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                                    <label className='text-primary ml-1'>Descripción de Muestra: {`${validation.values.description}`}</label>
                                    </div>
                                </div>
                            </div>
                            <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                            <label className='text-primary ml-1'>No. de solicitud: {`${validation.values.labRequestCode}`}</label>
                            </div>
                            <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                            <label className='text-primary ml-1'>Fecha de Recepción: {`${validation.values.receivedAt}`}</label>
                            </div>
                            <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                            <label className='text-primary ml-1'>Fecha de muestreo: {`${validation.values.dateAt}`}</label>
                            </div>
                            <div className='row my-1'>
                                <div className='col-3 col-md-4'>
                                    <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                                    <label className='text-primary ml-1'>Cantidad: {`${validation.values.quantity}`}</label>
                                    </div>
                                </div>
                                <div className='col-3 col-md-8'>
                                    <div className='text-primary row mx-4 my-3' style={{fontSize:'18px', color:'blue'}}>
                                    <label className='text-primary ml-1'>Unidad de Medida: {`${validation.values.unitMeasure}`}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-3 col-md-5 d-flex align-items-center'>
                            <div className="mt-3" >
                            <QRCode value={handleQrValue(validation.values.id)} size={230} />
                            </div>
                        </div>
                    </div>

                    <div className="row mx-4 mt-1 mb-2" style={{fontSize:'18px', color:'blue'}}>
                        <div className="col-3 col-md-12">
                            <label className='text-primary'>Observaciones</label>
                            {/* <Label className="form-label">Email</Label> */}
                            <Input
                                required
                                disabled={true}
                                name="observations"
                                className="form-control text-primary"
                                placeholder="Observaciones"
                                type="textarea"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.observations || ""}
                                invalid={
                                    validation.touched.observations && validation.errors.observations ? true : false
                                }
                            />
                            {validation.touched.observations && validation.errors.observations ? (
                                <FormFeedback type="invalid">{validation.errors.observations}</FormFeedback>
                            ) : null}
                        </div>
                    </div>

                    <div className='text-primary text-center' style={{fontSize:'20px', color:'blue'}}>
                        <b>Elaboró</b>
                    </div>
                    <div className='text-primary text-center mt-2' style={{fontSize:'20px', color:'blue'}}>
                        {userName}
                    </div>
                    <div className='text-primary text-center mt-3' style={{fontSize:'19px', color:'blue'}}>
                        <b>Firma</b>
                    </div>
                    <div className='row mt-3' style={{fontSize:'20px', color:'blue'}}>
                        <div className='col-3 col-md-4'>

                        </div>
                        <div className='col-3 col-md-4'>
                        <hr className='text-primary text-center' style={{height:'2px'}}/>
                        </div>
                        <div className='col-3 col-md-4'>

                        </div>
                    </div>

                </Form>
            </Container>
        </div>
    </React.Fragment>
    )
}
